"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndefinedOrNull = isUndefinedOrNull;
exports.isObject = isObject;
exports.isDate = isDate;
exports.isNotUndefinedOrNull = isNotUndefinedOrNull;
function isUndefinedOrNull(value) {
    return value === undefined || value === null;
}
/**
 * Checks if value is of type "object"
 *
 * @export
 * @param {*} value - value to check
 * @return {*}  {value is object}
 */
function isObject(value) {
    return value !== null && typeof value === "object";
}
/**
 * Checks if value is instance of Date
 *
 * @export
 * @param {*} value - value to check
 * @return {*}  {value is Date}
 */
function isDate(value) {
    return value instanceof Date;
}
/**
 * Checks if a value is defined, i.e., not `null` and not `undefined`.
 *
 * @export
 * @template T - The type of the value being checked.
 * @param {(T | null | undefined)} value - The value to check.
 * @return {value is T} - Returns `true` if the value is not `null` or `undefined`, otherwise `false`.
 */
function isNotUndefinedOrNull(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=value-checkers.js.map